import { getEventStore } from "@ancestors/models";
import * as Sentry from "@sentry/react";
import { useEffect, useMemo, useState } from "react";
import type { EventStoreContextValue } from "./eventStoreContext";
import { EventStoreContext } from "./eventStoreContext";

interface GlobalContextProviderProps {
  children: React.ReactNode;
}

export function EventStoreProvider({ children }: GlobalContextProviderProps) {
  // The `eventId` URL param overrides the default event, for example to isolate e2e tests against
  // deployed builds. It only applies while it is in the URL: without it the default event is used.
  const [eventId, setEventId] = useState(() => getUrlEventId());

  // When the eventId changes, the eventStore is updated
  const eventStore = useMemo(() => getEventStore({ eventId }), [eventId]);

  console.log("eventKey", eventStore.eventKey);

  // Update Sentry eventId tag when eventId changes
  useEffect(() => {
    if (eventId) {
      Sentry.setTag("eventId", eventId);
    } else {
      Sentry.setTag("eventId", null);
    }
  }, [eventId]);

  const contextValue = useMemo<EventStoreContextValue>(
    () => ({ eventStore, setEventId }),
    [eventStore, setEventId],
  );

  return <EventStoreContext value={contextValue}>{children}</EventStoreContext>;
}

function getUrlEventId() {
  // Earlier versions remembered the URL param in local storage, which kept it active after it was
  // removed from the URL
  localStorage.removeItem("ancestors:eventId");

  return new URLSearchParams(window.location.search).get("eventId");
}
